/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         28/04/25 - 19:59:10
 * Module name:  manage-session-v-data.const
 * File name:    manage-session-init-data.const.ts
 * IDE:          WebStorm
 */

import {ManageSessionResponseInterface, ManageTypeEnum} from '@shared/interface/main/manage-session.interface';
import {NO_INDEX_FIND} from '@shared/constants';

export const MANAGE_SESSION_INIT_DATA: ManageSessionResponseInterface = {
  customer_id: NO_INDEX_FIND,
  customer_level: NO_INDEX_FIND,
  customer_name: '',
  customer_initials: '',
  customer_enabled: false,
  allow_customers: false,
  allow_public_devs: false,
  user_level: NO_INDEX_FIND,
  manage_token: '',
  manage_type: ManageTypeEnum.inactive
}
